import { h, Component } from 'preact'
import cxs from 'cxs/component'

const Options = cxs('div')({
  fontSize: '.90em',
  color: 'rgb(171, 171, 171)',
  // fontWeight: 900,
})

const Option = cxs('span')({
  marginRight: '.5em',
  ':hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
})

const OptionsList = ({ options }) => {
  return (
    <Options>
      {options.map((option, index) => {
        return (
          <Option key={index} onClick={option.onClick}>
            {option.name}
          </Option>
        )
      })}
    </Options>
  )
}

export default OptionsList



// WEBPACK FOOTER //
// ./components/OptionsList.js